import * as common from '../system/computed/common.js';


let computedState = {
    ...common
}

let state = {

    appReady: false,

    userToken: null,
    userService: null,
    userInfo: {
        c_utente: "",
        name: "",
        email: "",
        title: "",
        internal: false
    },

    internalSearchResults: {},

    userTokenRoot: null,
    userInfoRoot: {},
    userServiceRoot: null,

    bookmarks: [],
    notifications: [],
    formData: {},
    pswreset: undefined,
    pswresetMessage: null,
    transientData: {},
    networkLoading: [],
    dataGridLoading: false,
    isOnline: true,

    downloads: [1, 2],

    enabledEmails: {},

    messages: [],
    messages_loader: false,

    infoCapigruppo: [],
    infoNumeratori: [],
    infoStatiOrdine: [],

    uiSidebarExpanded: null,
    uiGridOptionsExpanded: false,
    uiAreasExpanded: false,
    uiShowCustomer: false,
    uiViewMode: 'table',
    uiLoginEmail: "",
    uiLoginPassword: "",
    uiTableFontSize: 3,
    uiFilter: "tesy_normal",
    uiDocumentWidth: 100,
    uiContentWidth: 100,
    uiScrollInfo: 0,
    uiGridWidth: {},
    uiTouch: false,

    modalItems: [],
    menus: [],
    menusOpen: [],
    menusAcl: [],

    previewData: {},

    selfCliente: null,

    languages: [],
    language: 'it',
    route: "/",

    ssoLoginRunning: false,

    analytics: [],

    cacheParams: {},

    namespaceIndex: '',
    fullNamespace: '',
    networkDBStore: null,

    enable_routes: [],

    ultimo_run_ok: null,
    last_update: null,
    next_update: null,

    show_lang_list: false,

    // Biometric login (unlock del token salvato)
    biometricAvailable: false,   // dispositivo supporta autenticazione biometrica
    biometricEnabled: false,     // utente ha registrato una credenziale su questo dispositivo
    biometricLockActive: false,  // sessione in attesa di verifica biometrica
    biometricSetupPending: false,    // dopo il primo login: offerta di attivazione biometria
    userRefreshToken: null,         // refresh token in-memory (NON in persistentState)
    biometricRefreshPending: false, // true durante un silent refresh (per feedback visivo)
    biometricRelockActive: false,   // true quando il silent refresh è stato annullato dall'utente: mostra il lock overlay

    // PWA install prompt
    pwaInstallBannerVisible: false,  // mostra/nasconde il banner di installazione
    pwaInstallDeferredEvent: null,   // evento beforeinstallprompt catturato dal browser (non disponibile su iOS/Safari macOS)
    pwaInstallIsIos: false,          // true su Safari/iOS: mostra istruzioni manuali al posto del prompt nativo
    pwaInstallIsSafariMac: false,    // true su Safari macOS: mostra istruzioni "Aggiungi al Dock"

    // Push notifications
    pushNotificationSupported: false,    // browser supporta Web Push
    pushNotificationPermission: 'default', // 'default' | 'granted' | 'denied'
    pushNotificationSubscribed: false,   // subscription attiva sul dispositivo corrente
    pushNotificationLoading: false,      // operazione subscribe/unsubscribe in corso
    pushNotificationSetupPending: false, // banner di offerta attivazione visibile in questa sessione
    pushActiveEndpoints: null,           // endpoint attivi noti al BE (null finché il BE non espone il campo)

    // Push notification preferences (schermata preferenze tipi notifica)
    pushPreferences: [],
    pushPreferencesLoading: false,

}

export {state, computedState}
